import { NgClass, NgStyle } from '@angular/common';
import { Component, forwardRef, Input, Provider } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';

const CHECKBOX_LABELED_VALUE_ACCESSOR: Provider = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CheckboxLabeledComponent),
    multi: true,
};

@Component({
    selector: 'app-checkbox-labeled',
    standalone: true,
    imports: [CheckboxModule, FormsModule, NgClass, NgStyle],
    providers: [CHECKBOX_LABELED_VALUE_ACCESSOR],
    templateUrl: './checkbox-labeled.component.html',
})
export class CheckboxLabeledComponent implements ControlValueAccessor {
    @Input() binary: boolean = false;
    @Input() label: string = '';
    @Input() size: 'small' | 'normal' | 'large' = 'normal';
    @Input() disabled: boolean = false;
    @Input() name: string = '';
    @Input() value: any;
    @Input() formControlName: string = '';
    @Input() inputId: string = '';
    @Input() styleClass: string = '';
    @Input() style: { [key: string]: any } | null = null;
    @Input() ariaLabel: string = '';
    @Input() ariaLabelledBy: string = '';
    @Input() tabindex: number | null = null;
    @Input() trueValue: any = true;
    @Input() falseValue: any = false;
    @Input() labelStyleClass: string = '';
    @Input() labelStyle: { [key: string]: any } | null = null;
    @Input() autoFocus: boolean = false;
    @Input() readonly: boolean = false;
    @Input() required: boolean = false;
    @Input() variant: 'outlined' | 'filled' | undefined = undefined;

    model: any;
    isDisabled = false;

    private onChange = (value: any) => {};
    private onTouched = () => {};

    writeValue(value: any): void {
        this.model = value;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    handleModelChange(value: any): void {
        this.model = value;
        this.onChange(value);
    }

    handleBlur(): void {
        this.onTouched();
    }

    
}
